import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { CommisionService } from "./CommisionService";

export const DownlineProduct = createAsyncThunk(
    "ls/DownlineProduct",
    async (payload, { rejectWithValue, getState, dispatch }) => {
        try {
            const response = await CommisionService.commisionModule().DownlineProduct(
                payload
            );
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message);
            return error?.response;
        }
    }
);

export const MoveCommision = createAsyncThunk(
    "ls/MoveCommision",
    async (payload, { rejectWithValue, getState, dispatch }) => {
        try {
            const response = await CommisionService.commisionModule().MoveCommision(
                payload
            );
            return response?.data;
        } catch (error) {
            toast.error(error?.response?.data?.message);
            return rejectWithValue(error?.response);
        }
    }
);

export const ReportsSlice = createSlice({
    name: "commision",
    initialState: "",
    extraReducers: {
        [DownlineProduct.pending]: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        [DownlineProduct.fulfilled]: (state, action) => {
            return {
                ...state,
                DownlineProduct: action.payload,
                loading: false,
            };
        },
        [DownlineProduct.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        },

        [MoveCommision.pending]: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        [MoveCommision.fulfilled]: (state, action) => {
            return {
                ...state,
                MoveCommision: action.payload,
                loading: false,
            };
        },
        [MoveCommision.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        },
    },
});

export default ReportsSlice.reducer;
